import { from, Observable, of } from "rxjs";
import { catchError, concatMap, map } from "rxjs/operators";
import { logD, logE } from "@blacknut/logging/dist";
import { getNTPTime } from "../api/Utils/getNTPTime";
import crypoProvider from "../crypto/CryptoProvider";
import { UserAgent } from "..";
import { TAG } from "../api/ApiService";
const NTP_DRIFT: (number | undefined)[] = [undefined];
let LAST_ENCRYPTED_TOKEN: { time: number; token: string } | undefined;

const getNTPDrift = () => {
  if (NTP_DRIFT[0] !== undefined) {
    return of(NTP_DRIFT[0]);
  }
  return getNTPTime()
    .pipe(
      map((res) => {
        const dist = res.getTime();
        const local = new Date().getTime();
        const diff = Math.round((dist - local) / 1000);
        logD(TAG, "NTP date is : dist=%o, local=%o, diff=%o s", dist, local, diff);
        NTP_DRIFT[0] = diff;
        return diff;
      }),
    )
    .pipe(
      catchError((e) => {
        logE(TAG, "Caught error getting NTP", e);
        return of(0);
      }),
    );
};

export const generateSecureToken = (
  userAgent: UserAgent,
): Observable<string | undefined> => {
  if (
    userAgent.apiVersion &&
    userAgent.apiVersion.localeCompare("5.0.2", undefined, {
      numeric: true,
      sensitivity: "base",
    }) >= 0 &&
    crypoProvider.service
  ) {
    return getNTPDrift().pipe(
      concatMap((drift) => {
        const time = Math.round(Date.now() / 1000) + (drift || 0);
        logD(TAG, "Corrected time is %o", time);
        if (
          LAST_ENCRYPTED_TOKEN &&
          time - LAST_ENCRYPTED_TOKEN.time < 2 * 60 /* valid 900s according to PM*/
        ) {
          logD(
            TAG,
            "Returning previous value (diff = %o)",
            time - LAST_ENCRYPTED_TOKEN.time,
          );
          return of(LAST_ENCRYPTED_TOKEN.token);
        }
        return from(crypoProvider.service!.encrypt(`${time}`)).pipe(
          map((obf) => {
            const res = `${time}${obf}`;
            LAST_ENCRYPTED_TOKEN = { time, token: res };
            return res;
          }),
        );
      }),
    );
  }
  return of(undefined);
};
export default generateSecureToken;
